import { Modal, Row, Col, Form} from 'react-bootstrap'
import { useEffect, useState, useRef } from "react";
import { Dropdown, Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { FormInputElement } from '../../Form/FormInputElement';
import { useApiClient } from '../../../ApiService/useApiClient';


const EditClientSection3 = ({show,setShowAddEdit, data, setdata}) => {

    const api = useApiClient();

    const formDefault = {
        opened: true,
        modalTitle:"Client Details",  
      }
  
      const [formModal, setFormModal] = useState(formDefault);
      const [error,setError] = useState(null);
      const modalForm = useRef(null);
      

      useEffect(()=>{

        let checkdef = false;
        if(data.isClientAwareOfReferral==1) checkdef = true;

        setFormModal({...formModal, opened:show , action:'add'
                , referralReceivedDate:data.referralReceivedDate,
                isClientAwareOfReferral:checkdef,
                contractDate:data.contractDate,
                serviceStartDate:data.serviceStartDate,       
                serviceEndDate:data.serviceEndDate       
                });        

      },[show]);

      
    function closeFormModal(){
        const updateFormModal = {...formModal, opened:false}
        setFormModal(updateFormModal);
        setShowAddEdit(false);
      }
  

      function handleAddEvent(e){        
        closeFormModal();
    }

    function handleEditEvent(e){     
      //closeFormModal();
  }


      function handleFormSubmit(event){
  
        event.preventDefault();
        let referralReceivedDate = modalForm.current.querySelector('#referralReceivedDate').value; 
        let isClientAwareOfReferral = modalForm.current.querySelector('#isClientAwareOfReferral').value; 
        let contractDate = modalForm.current.querySelector('#contractDate').value; 
        let serviceStartDate = modalForm.current.querySelector('#serviceStartDate').value; 
        let serviceEndDate = modalForm.current.querySelector('#serviceEndDate').value; 

        let isClientAwareOfReferralBool = 0
        if(isClientAwareOfReferral=="on"){
          isClientAwareOfReferralBool = 1
        }                  
         
        const frmFormData = new FormData();
        frmFormData.append("CustomerId", data.customerId) 
        frmFormData.append("ReferralReceivedDate", referralReceivedDate) 
        frmFormData.append("IsClientAwareOfReferral", isClientAwareOfReferralBool) 
        frmFormData.append("ContractDate", contractDate)  
        frmFormData.append("ServiceStartDate", serviceStartDate)  
        frmFormData.append("ServiceEndDate", serviceEndDate)  
      
        const sURL = "HMCareData/customer/modify/";
        
        //console.log(frmFormData);
        //return null

        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;              
            setdata(updatedDataObj)          
            closeFormModal();
                        
        }).catch(error => {
            setError(error);     
            console.log({error})
        });
        
      return null
          
      
    }


  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
<Form ref={modalForm} onSubmit={handleFormSubmit}>
    <Modal.Header closeButton>
    <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
    </Modal.Header>                
    <Modal.Body>

        {false && <Spinner animation="border" variant="primary" />}             

        {<Row className="g-gs">   

            <FormInputElement type="date" id="referralReceivedDate" Label="Referral Received Date" defaultValue={formModal.referralReceivedDate}  placeholder=""/>            
            <FormInputElement type="switch" id="isClientAwareOfReferral" Label="Is Client Aware Of Referral" defaultValue={formModal.isClientAwareOfReferral}/>
            <FormInputElement type="date" id="contractDate" Label="Contract Date" defaultValue={formModal.contractDate}  placeholder=""/>
            <FormInputElement type="date" id="serviceStartDate" Label="service Start Date" defaultValue={formModal.serviceStartDate}  placeholder=""/>
            <FormInputElement type="date" id="serviceEndDate" Label="service End Date" defaultValue={formModal.serviceEndDate}  placeholder=""/>
                        
        </Row>}
    </Modal.Body>
    <Modal.Footer>                    
        <Button variant="danger" onClick={closeFormModal}>Discard</Button>                
        <Button variant="primary" type="submit" onClick={handleEditEvent}>Update</Button>
    </Modal.Footer>
</Form>
</Modal>
  )
}

export default EditClientSection3